import React from 'react';

export function CustomActiveDot(props: any) {
    const {cx, cy, value, dotColor} = props;

    const color = value[1] >= 0 ? dotColor : '#EC7063';

    return <circle cx={cx} cy={cy} r={4} fill={color} />;
}
